import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { DetailCheckbox } from "@/components/ui/checkbox"
import { FormField } from "@/components/ui/form"
import { TranslatedFieldError } from "@/components/ui/form-field-error"
import { displayForData } from "@/modules/admin/news/helpers/news-helper"
import { NewsForm } from "@/modules/admin/news/types"

const NewsSectionUserRolesForm = () => {
  const { t } = useTranslation()

  const form = useFormContext<NewsForm>()

  const {
    control,
    formState: { errors },
  } = form

  return (
    <div className="flex flex-col gap-2">
      <label className="text-on-surface-subdued text-sm">{t("admin.news.form.showTo")}*</label>
      <div className="flex flex-row gap-2">
        {displayForData.map((field) => (
          <FormField
            key={field.value}
            control={control}
            name={"displayFor"}
            render={({ field: { onChange, value = [] } }) => {
              return (
                <DetailCheckbox
                  checked={value.includes(field.value)}
                  onCheckedChange={(checked) => {
                    const checkedValues = checked
                      ? [...value, field.value].sort((a, b) => a.localeCompare(b))
                      : value.filter((value) => value !== field.value)
                    onChange(checkedValues)
                  }}>
                  {t(field.label)}
                </DetailCheckbox>
              )
            }}
          />
        ))}
      </div>
      {errors.displayFor && (
        <TranslatedFieldError message={errors.displayFor?.message} errors={errors} name="displayFor" />
      )}
    </div>
  )
}

export default NewsSectionUserRolesForm
